import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
    {
        path: "/",
        name: 'home',
        component: ()=>import("@/view/VueHome.vue")
    },
    {
        path: "/SERVICES",
        name: 'services',
        component: ()=>import("@/view/AiflogServer.vue")
    },
    {
        path: "/SERVICES/baggage",
        name: 'baggage',
        component: ()=>import("@/view/AiflogBaggage.vue")
    },
    {
        path: "/REFERENCES",
        name: 'References',
        component: ()=>import("@/view/References.vue")
    },
    {
        path: "/CONTACTUS",
        name: 'CONTACTUS',
        component: ()=>import("@/view/AiflogContactUs.vue")
    },
    {
        path: "/CAPABILTIES",
        name: 'Capabilities',
        component: ()=>import("@/view/Capabilities.vue")
    },
    {
        path: "/KEY-PROJECTS/TAI-YUAN-Airport",
        name: 'TAI-YUAN-Airport',
        component: ()=>import("@/view/AiflogTaiYuan.vue")
    },{
        path: "/KEY-PROJECTS/SHEN-ZHEN-T3",
        name: 'SHEN-ZHEN-T3',
        component: ()=>import("@/view/AiflogSHUNFENGT3.vue")
    },{
        path: "/KEY-PROJECTS/SHEN-ZHEN-SatelliteHall",
        name: 'SHEN-ZHEN-SatelliteHall',
        component: ()=>import("@/view/AiflogSHENZHENSatelliteHall.vue")
    },
    {
        path: "/KEY-PROJECTS/YAN-TAI-T2",
        name: 'YAN-TAI-T2',
        component: ()=>import("@/view/AiflogYANTAIT2.vue")
    },{
        path: "/KEY-PROJECTS/ZHU-HAI-T2",
        name: 'ZHU-HAI-T2',
        component: ()=>import("@/view/AiflogZHUHAIT2.vue")
    },{
        path: "/KEY-PROJECTS/SHOU-DU-T2",
        name: 'SHOU-DU-T2',
        component: ()=>import("@/view/AiflogSHOUDUT2.vue")
    },
    {
        path: "/KEY-PROJECTS/FU-ZHOU-T2",
        name: 'FU-ZHOU-T2',
        component: ()=>import("@/view/AiflogFUZHOUT2.vue")
    },
    {
        path: "/KEY-PROJECTS/TAI-YUAN-T3",
        name: 'TAI-YUAN-T3',
        component: ()=>import("@/view/AiflogTAIYUANT3.vue")
    },{
        path: "/KEY-PROJECTS/SHUN-FENG",
        name: 'SHUN-FENG',
        component: ()=>import("@/view/AiflogSHUNFENG.vue")
    },
    {
        path: "/KEY-PROJECTS/DA-LIAN-BHS",
        name: 'DA-LIAN-BHS',
        component: ()=>import("@/view/AiflogDALIANXINGLI.vue")
    },
    {
        path: "/KEY-PROJECTS/NAN-CHANG-BHS",
        name: 'NAN-CHANG-BHS',
        component: ()=>import("@/view/AiflogCHANGBEIXINGLI.vue")
    },
    {
        path: "/KEY-PROJECTS/NAN-CHANG-Simulation",
        name: 'NAN-CHANG-Simulation',
        component: ()=>import("@/view/AiflogCHANGBEIFANGZHEN.vue")
    },
    {
        path: "/KEY-PROJECTS/YANG-ZHOU-T2",
        name: 'YANG-ZHOU-T2',
        component: ()=>import("@/view/AiflogYANGZHOU.vue")
    },{
        path: "/KEY-PROJECTS/HE-FEI-T2",
        name: 'HE-FEI-T2',
        component: ()=>import("@/view/AiflogHEFEI.vue")
    },
    {
        path: "/SERVICES/Baggage-Handing-Sysyems-Simulation",
        name: 'Baggage-Handing-Sysyems-Simulation',
        component: ()=>import("@/view/AIflogBaggageSimulation.vue")
    },
    {
        path: "/SERVICES/Passenger-Process-Simulation",
        name: 'Passenger-Process-Simulation',
        component: ()=>import("@/view/AiflogPassengerProcessSimulation.vue")
    }
]

const router = createRouter({

    history:createWebHashHistory(),
    routes
})



export default router;